import { createAction } from '@reduxjs/toolkit';
import { RequestError } from 'types';
import { State } from './types';

export const fetchCommunicationsSituations = createAction('communications-situations/fetch', () => ({
  payload: undefined,
}));

export const fetchedCommunicationsSituations = createAction(
  'communications-situations/fetched',
  (data?: State['data'], error?: RequestError) => ({
    payload: error || data,
    error: Boolean(error),
  })
);

export default {
  fetchedCommunicationsSituations,
  fetchCommunicationsSituations,
};
